(function () {
  function isExplicitSizePicker(picker) {
    return picker && picker.dataset.ffExplicitSize === "true";
  }

  function syncAvailableAddButton(variantRadios) {
    if (isExplicitSizePicker(variantRadios)) return;
    if (!variantRadios || !variantRadios.currentVariant || !variantRadios.currentVariant.available) {
      return;
    }

    if (typeof variantRadios.toggleAddButton === "function") {
      variantRadios.toggleAddButton(false, window.variantStrings && window.variantStrings.addToCart);
    }

    var productForm = document.getElementById("product-form-" + variantRadios.dataset.section);
    var addButton = productForm && productForm.querySelector('[name="add"]');
    var addButtonText = productForm && productForm.querySelectorAll('[name="add"] > span');

    if (!addButton) {
      return;
    }

    addButton.removeAttribute("disabled");
    addButton.removeAttribute("aria-disabled");

    if (addButtonText && window.variantStrings && window.variantStrings.addToCart) {
      addButtonText.forEach(function (element) {
        element.innerHTML = window.variantStrings.addToCart;
      });
    }
  }

  function autoSelectAvailableVariant(variantRadios) {
    if (isExplicitSizePicker(variantRadios)) return;
    if (!variantRadios) {
      return;
    }

    if (variantRadios.currentVariant && variantRadios.currentVariant.available) {
      syncAvailableAddButton(variantRadios);
      return;
    }

    var fieldsets = Array.from(variantRadios.querySelectorAll("fieldset"));
    var selectedOptions = fieldsets.map(function (fieldset) {
      var checked = fieldset.querySelector("input:checked");
      return checked && checked.value;
    });

    var availableVariants = (variantRadios.variantData || []).filter(function (variant) {
      return variant.available;
    });

    if (!availableVariants.length) {
      return;
    }

    var fallbackVariant =
      availableVariants.find(function (variant) {
        return variant.option1 === selectedOptions[0] && variant.option2 === selectedOptions[1] && variant.option3 === selectedOptions[2];
      }) ||
      availableVariants.find(function (variant) {
        return variant.option1 === selectedOptions[0];
      }) ||
      availableVariants.find(function (variant) {
        return variant.option2 === selectedOptions[1];
      }) ||
      availableVariants[0];

    if (!fallbackVariant) {
      return;
    }

    fieldsets.forEach(function (fieldset, index) {
      var wantedValue = fallbackVariant.options[index];
      var input = Array.from(fieldset.querySelectorAll("input")).find(function (radio) {
        return radio.value === wantedValue;
      });

      if (input) {
        input.checked = true;
      }
    });

    variantRadios.updateOptions();
    variantRadios.updateMasterId();
    variantRadios.updateVariantStatuses();
    variantRadios.updateURL();
    variantRadios.updateVariantInput();
    variantRadios.renderProductInfo();
    variantRadios.previousVariant = variantRadios.currentVariant;
    variantRadios.dispatchEvent(new CustomEvent("variant:change", { detail: { variant: variantRadios.currentVariant } }));
    syncAvailableAddButton(variantRadios);
    window.setTimeout(function () {
      syncAvailableAddButton(variantRadios);
    }, 500);
    window.setTimeout(function () {
      syncAvailableAddButton(variantRadios);
    }, 1200);
  }

  function patchVariantRadios() {
    var VariantRadios = window.customElements && window.customElements.get("variant-radios");

    if (!VariantRadios || VariantRadios.prototype.__ffAutoAvailableVariantPatch) {
      return;
    }

    var originalOnVariantChange = VariantRadios.prototype.onVariantChange;

    VariantRadios.prototype.onVariantChange = function (event) {
      originalOnVariantChange.call(this, event);
      if (!isExplicitSizePicker(this)) autoSelectAvailableVariant(this);
    };

    VariantRadios.prototype.__ffAutoAvailableVariantPatch = true;
  }

  if (!document.__ffAutoAvailableVariantListener) {
    document.addEventListener("change", function (event) {
      var variantRadios = event.target && event.target.closest && event.target.closest("variant-radios");

      if (!variantRadios || isExplicitSizePicker(variantRadios)) {
        return;
      }

      window.setTimeout(function () {
        autoSelectAvailableVariant(variantRadios);
        syncAvailableAddButton(variantRadios);
      }, 100);
      window.setTimeout(function () {
        syncAvailableAddButton(variantRadios);
      }, 800);
    });

    document.__ffAutoAvailableVariantListener = true;
  }

  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined("variant-radios").then(patchVariantRadios);
  }

  patchVariantRadios();
  document.addEventListener("shopify:section:load", patchVariantRadios);
})();
